import React, { useState } from 'react';
import Chart from "react-apexcharts";
import 'react-datepicker/dist/react-datepicker.css';
import { PostApiMethod } from '../../core/services/apiService';
import { dashboardChartProps } from '../../core/dto/dashboard.dto';

const MissedCallNoAgentChart = ({ apiEndpoint, startDate, endDate, selectedLocation, selectedCallType, onChartLoaded }: dashboardChartProps) => {
    const [chartData, setChartData] = useState<any>();
    const [loaded, setLoaded] = React.useState(false);

    React.useEffect(() => {
        let isMounted = true;
        (async () => {
            try {
                const payload = {
                    from_date: startDate ? startDate.toLocaleDateString("en-CA") : null,
                    to_date: endDate ? endDate.toLocaleDateString("en-CA") : null,
                    location_id: selectedLocation,
                    call_direction: "Missed Call - No Agents",
                    clientTZ: Intl.DateTimeFormat().resolvedOptions().timeZone
                };

                const response = await PostApiMethod(apiEndpoint, payload);
                const labels: string[] = [];
                const data: number[] = [];

                response?.data?.data?.forEach((element: any) => {
                    const date = Object.keys(element)[0];
                    const value = element[date];
                    const dateWithTime = date.includes(':') ? date : `${date}T12:00:00`;
                    labels.push(dateWithTime);
                    // labels.push(date);
                    data.push(value);
                });

                let startDtTime = "";
                let endDtTime = "";
                if (labels?.length > 0) {
                    startDtTime = labels[0];
                    endDtTime = labels[labels?.length - 1];
                }

                let count = data?.reduce((sum, val) => sum + val, 0);
                const options: any = {
                    chart: {
                        id: "line-chart",
                        type: "line",
                        zoom: { enabled: true },
                        toolbar: {
                            show: true,
                            tools: {
                                download: true,
                                selection: false,
                                zoom: false,
                                zoomin: false,
                                zoomout: false,
                                pan: false,
                                reset: false,
                            },
                        },
                    },
                    stroke: { curve: "smooth", width: 2 },
                    xaxis: {
                        categories: labels,
                        type: "datetime",
                        min: new Date(startDtTime)?.getTime(),
                        max: new Date(endDtTime)?.getTime(),
                        labels: {
                            datetimeUTC: false,
                            rotate: -45,
                            trim: false,
                            rotateAlways: true,
                            style: { fontSize: "12px" },
                            datetimeFormatter: {
                                year: 'yyyy',
                                month: 'MMM \'yy',
                                day: 'dd MMM',
                                hour: 'hh:mm TT'
                            }
                        }
                    },
                    grid: { padding: { bottom: 20 } },
                    yaxis: { title: { text: "Value" }, style: { fontSize: "16px" } },
                    dataLabels: { enabled: false },
                    markers: {
                        size: 4,
                        colors: ["#439a43"],
                        strokeColors: "#00ff80",
                        strokeWidth: 2,
                        hover: { size: 7 },
                    },
                };

                const seriesData = labels?.map((time, index) => ({ x: time, y: data[index] }));
                let series = [{ name: '', data: seriesData }];
                let chartData = { labels: options, series: series, count: count }
                if (isMounted) {
                    setChartData(chartData);
                    if (!loaded) {
                        onChartLoaded?.();
                        setLoaded(true);
                    }
                }
            } catch (error) {
                console.error('Error fetching chart data:', error);
            }
        })();
        return () => { isMounted = false };
    }, [startDate, endDate, selectedLocation, apiEndpoint]);

    const callForwardChartData = React.useMemo(() =>
        chartData,
        [chartData]);

    return (
        <div className="overflow-hidden">
            <div className="row mb-3 chart-header" style={{ borderBottom: '2px solid #ddd', paddingBottom: '10px' }}>
                <div className="col-12"><h5 className="text-center">Missed Call - No Agents Calls</h5></div>
            </div>
            <div className="col-12">
                {callForwardChartData && callForwardChartData.count > 0 ? (
                    <Chart options={chartData.labels} series={chartData.series} type="line" height={380} />
                ) : (
                    <div className="text-center py-4">No Records Found</div>
                )}
            </div>
        </div>
    );
};

export default MissedCallNoAgentChart;
